import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import index2 from '@/components/index2Device'
import selectChara from '@/components/selectChara'
import updateLog from '@/components/updateLog'
import shop from '@/components/shop'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/index',
      name: 'index',
      component: index2
    },
    {
      path: '/index2',
      name: 'index2',
      component: index2
    },
    {
      path: '/inventory',
      name: 'inventory',
      component: index2
    },
    {
      path: '/selectChara',
      name: 'selectChara',
      component: selectChara
    },
    {
      path: '/shop',
      name: 'shop',
      component: shop
    },
    {
      path: '/updateLog',
      name: 'updateLog',
      component: updateLog
    },
    {
      path: '/spirit-farm',
      name: 'SpiritFarm',
      component: () => import('@/components/spiritFarm/SpiritFarm')
    },
    {
      path: '/xiuxian-monopoly',
      name: 'XianMonopoly',
      component: () => import('@/components/monopoly/XianMonopoly')
    },
    {
      path: '/taixu-rogue',
      name: 'TaixuRogue',
      component: () => import('@/components/rogue/TaixuRogue')
    },
    {
      path: '/im',
      name: 'Im',
      component: () => import("@/components/Im"),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js